var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"stripe-mobile-redirect"}},[_c('b-button',{on:{"click":_vm.redirect}},[_vm._v("Open SH App")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }